import { render, staticRenderFns } from "./IndicatorsPoints.vue?vue&type=template&id=c47894ea&scoped=true&lang=pug"
import script from "./IndicatorsPoints.vue?vue&type=script&lang=js"
export * from "./IndicatorsPoints.vue?vue&type=script&lang=js"
import style0 from "./IndicatorsPoints.vue?vue&type=style&index=0&id=c47894ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47894ea",
  null
  
)

export default component.exports